import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { AppPermissionService } from './app-permission.service';
import { AppAuszugCookieService } from './app-auszug-cookie-service';
import { HistoryMode } from './HistoryMode';

@Injectable()
export class AppConfigService implements OnDestroy {

  private kantonSubject = new BehaviorSubject<string>('BI');
  kanton$ = this.kantonSubject.asObservable();
  private kantonChangeSubject = new Subject();
  kantonChange$ = this.kantonChangeSubject.asObservable();

  private versionSubject = new BehaviorSubject<string>('unknown');
  version$ = this.versionSubject.asObservable();

  private einstellungHistorischeDatenSubject = new BehaviorSubject<HistoryMode.HistoryMode>('OHNE_HIST');
  einstellungHistorischeDaten$ = this.einstellungHistorischeDatenSubject.asObservable();

  private einstellungHistorischeDatenEventSubject = new Subject<any>();
  historisiertEvent$ = this.einstellungHistorischeDatenEventSubject.asObservable();

  private subscription: Subscription;

  constructor(private permissionService: AppPermissionService,
              private anzeigeSettingsService: AppAuszugCookieService) {
    this.kantonSubject.next(environment.kanton);
    this.versionSubject.next(environment.versionNr);
    this.subscription = this.permissionService.initialized$.subscribe(PermissionsInitialized => {
      if (PermissionsInitialized) {
        this.initHistoryStateFromCookie();
      }
    });
  }

  switchEinstellungHistorischeDaten() {
    let val = this.einstellungHistorischeDaten;
    if (val === HistoryMode.HistoryMode.OHNE_HIST && this.hasPermissionAnzeigeHistorischeEintraege) {
      val = HistoryMode.HistoryMode.MIT_HIST;
    } else {
      val = HistoryMode.HistoryMode.OHNE_HIST;
    }
    this.setMode(val);
  }

  setMode(val) {
    this.einstellungHistorischeDatenSubject.next(val);
    this.anzeigeSettingsService.updateHistorisiertCookie(HistoryMode.HistoryMode.MIT_HIST === val);
    this.einstellungHistorischeDatenEventSubject.next(null);
  }

  setKanton(kanton: string) {
    this.kantonSubject.next(kanton);
    this.kantonChangeSubject.next(null);
  }

  initHistoryStateFromCookie() {
    let historisiert;
    if (this.hasPermissionAnzeigeHistorischeEintraege) {
      historisiert = this.anzeigeSettingsService.readHistorisiertCookie();
    } else {
      historisiert = HistoryMode.HistoryMode.OHNE_HIST;
    }
    this.einstellungHistorischeDatenSubject.next(historisiert);
  }

  get kanton() {
    return this.kantonSubject.getValue();
  }

  get versionNr() {
    return this.versionSubject.getValue();
  }

  get einstellungHistorischeDaten(): HistoryMode.HistoryMode {
    return this.einstellungHistorischeDatenSubject.getValue();
  }

  get hasPermissionAnzeigeHistorischeEintraege(): boolean {
    return this.permissionService.hasPermission('ANZEIGE_HISTORISCHE_EINTRAEGE');
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

}
